import React from 'react';
import classNames from 'styles/utils/classNames';
import { BadgeProps } from './types';

export default function Badge({
  label="Badge",
  variant="primary",
  size="md",
  className,
  ...rest
}: BadgeProps) {
  return (
    <div className={classNames('rounded-full mr-3',
      !!size && size === 'xs' && 'typography-product-button-label-xs px-4 py-1.5',
      !!size && size === 'sm' && 'typography-product-button-label-small px-4 py-2',
      !!size && size === 'md' && 'typography-product-subheading px-4 py-2',
      !!size && size === 'lg' && 'typography-product-heading-compact px-8 py-4',
      variant === 'primary' &&
      'bg-color-bg-lightmode-brand-secondary text-color-text-brand dark:bg-color-bg-darkmode-brand-secondary',
      variant === 'secondary' &&
      'bg-color-bg-lightmode-brand text-color-text-lightmode-invert dark:text-color-text-darkmode-invert',
      !!className && className,)}
      {...rest}
    >
      {label}
    </div>
  );
}